// import { paginationDataToShow } from "../actions/generalActions";
import {
  CATEGORIES_CREATE_REQUEST,
  CATEGORIES_CREATE_SUCCESS,
  CATEGORIES_CREATE_FAIL,
  ALL_CATEGORIES_VIEW_REQUEST,
  ALL_CATEGORIES_VIEW_SUCCESS,
  ALL_CATEGORIES_VIEW_FAIL,
  CATEGORY_UPDATE_REQUEST,
  CATEGORY_UPDATE_SUCCESS,
  CATEGORY_UPDATE_FAIL,
} from "../constants";

export const categoriesReducer = (
  state = {
    // categories: {
    //   categories: null,
    // },
    categories: {
      categories: null,
      from: null,
      to: null,
      loading: false,
    },
  },
  action
) => {
  switch (action.type) {
    case CATEGORIES_CREATE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case CATEGORIES_CREATE_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case CATEGORIES_CREATE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // CATEGORIES VIEW TABLE
    case ALL_CATEGORIES_VIEW_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ALL_CATEGORIES_VIEW_SUCCESS:
      return {
        ...state,
        loading: false,
        categories: action.payload,
      };
    case ALL_CATEGORIES_VIEW_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // CATEGORY UPDATE
    case CATEGORY_UPDATE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case CATEGORY_UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        // old code hata dya
        categories: state.categories.map((x) =>
          x.id == action.payload.id ? action.payload : x
        ),
      };
    case CATEGORY_UPDATE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
